"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getZipURL = exports.getRiskWidgetURL = exports.ZIP_CODE_VALIDATION_REGEX = exports.ZIP_CART_MIN_AMOUNT = exports.ZIP_CART_MAX_AMOUNT = exports.VISA_REGEX = exports.SUPPORTED_COUNTRY_LOCALE_LIST = exports.STATES_URL = exports.PIXEL_TRACKING_PREPROD_URL = exports.PHONE_NUMBER_VALIDATION_REGEX = exports.PAYMENT_METHOD_LIST = exports.PAYMENT_METHOD_ALIAS = exports.PAYMENT_METHODS_URL = exports.PAYMENT_METHODS = exports.NUMBERS_ONLY = exports.NAME_VALIDATION_REGEX = exports.MODIFIED_INITIATE_PAYMENT_URL = exports.MODIFIED_AUTHORIZE_URL = exports.MASTER_CARD_REGEX = exports.LAST_NAME_FIELD_MAX = exports.INITIATE_PAYMENT_URL = exports.GOOGLE_PAY_SCRIPT_URL = exports.GOOGLE_ANALYTICS_CODE = exports.FULL_NAME_FIELD_MAX = exports.FIRST_NAME_FIELD_MAX = exports.EMOJI_REGEX = exports.EMAIL_VALIDATION_REGEX = exports.DISCOVER_CARD_REGEX = exports.DINERS_CLUB_CARD_REGEX = exports.DELETE_TOKEN_URL = exports.DATA_DOME_CLIENT_KEY = exports.DATA_DOME_CAPTCHA_SCRIPT_URL = exports.CHECKOUT_URL = exports.CHECKOUT_DETAILS_URL = exports.CARD_TYPES = exports.CARD_NUMBER_VALIDATION_REGEX = exports.CARD_EXPIRY_VALIDATION_REGEX = exports.CARD_CVV_VALIDATION_REGEX = exports.BILLING_ADDRESS_VALIDATION_REGEX = exports.BASE_URL_QA = exports.BASE_URL_PROD = exports.BASE_URL_PRE_PROD = exports.AUTH_VALIDATE_URL = exports.AUTHORIZE_URL = exports.AMEX_CARD_REGEX = exports.ADYEN_PAYMENT_METHOD_TYPES = void 0;
// Payment Plus url's
var BASE_URL_QA = 'https://apiqa.blackhawknetwork.com/';
exports.BASE_URL_QA = BASE_URL_QA;
var BASE_URL_PRE_PROD = 'https://notificationpp.blackhawknetwork.com/';
exports.BASE_URL_PRE_PROD = BASE_URL_PRE_PROD;
var BASE_URL_PROD = 'https://notification.blackhawknetwork.com/';
exports.BASE_URL_PROD = BASE_URL_PROD;
var PIXEL_TRACKING_PREPROD_URL = 'https://payment-pg-pp.blackhawknetwork.com';

// export const PAYMENT_METHODS_URL = 'paymentplusProcessing/v1/paymentMethods';
// Payment method url has been upgraded
exports.PIXEL_TRACKING_PREPROD_URL = PIXEL_TRACKING_PREPROD_URL;
var PAYMENT_METHODS_URL = 'paymentplusProcessing/v1/paymentMethodsV2';
exports.PAYMENT_METHODS_URL = PAYMENT_METHODS_URL;
var AUTHORIZE_URL = 'paymentplusProcessing/v1/authorize';
exports.AUTHORIZE_URL = AUTHORIZE_URL;
var AUTH_VALIDATE_URL = 'paymentplusProcessing/v1/authorize/validate';
exports.AUTH_VALIDATE_URL = AUTH_VALIDATE_URL;
var CHECKOUT_URL = 'paymentplusProcessing/v1/checkout/';
exports.CHECKOUT_URL = CHECKOUT_URL;
var INITIATE_PAYMENT_URL = '/initiatepayment';
exports.INITIATE_PAYMENT_URL = INITIATE_PAYMENT_URL;
var STATES_URL = 'paymentplusProcessing/v1/states/';
exports.STATES_URL = STATES_URL;
var DELETE_TOKEN_URL = 'paymentplusProcessing/v1/cardToken?token=';
exports.DELETE_TOKEN_URL = DELETE_TOKEN_URL;
var MODIFIED_INITIATE_PAYMENT_URL = function MODIFIED_INITIATE_PAYMENT_URL(checkoutId) {
  return "paymentplusProcessing/v1/checkout/".concat(checkoutId, "/initiatepayment");
};
exports.MODIFIED_INITIATE_PAYMENT_URL = MODIFIED_INITIATE_PAYMENT_URL;
var MODIFIED_AUTHORIZE_URL = function MODIFIED_AUTHORIZE_URL(checkoutId) {
  return "paymentplusProcessing/v1/checkout/".concat(checkoutId, "/authorize");
};
exports.MODIFIED_AUTHORIZE_URL = MODIFIED_AUTHORIZE_URL;
var CHECKOUT_DETAILS_URL = function CHECKOUT_DETAILS_URL(checkoutId) {
  return "paymentplusProcessing/v1/checkout/".concat(checkoutId, "/details");
};
exports.CHECKOUT_DETAILS_URL = CHECKOUT_DETAILS_URL;
var getZipURL = function getZipURL(environment) {
  return environment === 'live' ? 'https://cdn.us.zip.co/v1/zip.js' : 'https://cdn.sand.us.zip.co/v1/zip.js';
};
exports.getZipURL = getZipURL;
var GOOGLE_PAY_SCRIPT_URL = 'https://pay.google.com/gp/p/js/pay.js';
exports.GOOGLE_PAY_SCRIPT_URL = GOOGLE_PAY_SCRIPT_URL;
var getRiskWidgetURL = function getRiskWidgetURL(environment) {
  return environment === 'live' ? 'https://content.blackhawknetwork.com/riskwidget/v1/widget.js' : 'https://contentpp.blackhawknetwork.com/riskwidget/v1/widget.js';
};

//Payment Methods
exports.getRiskWidgetURL = getRiskWidgetURL;
var PAYMENT_METHODS = ['CREDIT_CARD', 'PAYPAL', 'GOOGLE_PAY', 'MASTERPASS', 'AMEX_CHECKOUT', 'APPLE_PAY', 'ANDROID_PAY', 'VISA_CHECKOUT', 'SAMSUNG_PAY', 'ADYEN_DROPIN', 'ADYEN_CREDIT_CARD'];

// Field attributes
exports.PAYMENT_METHODS = PAYMENT_METHODS;
var FIRST_NAME_FIELD_MAX = 15;
exports.FIRST_NAME_FIELD_MAX = FIRST_NAME_FIELD_MAX;
var LAST_NAME_FIELD_MAX = 25;
exports.LAST_NAME_FIELD_MAX = LAST_NAME_FIELD_MAX;
var FULL_NAME_FIELD_MAX = 35;
exports.FULL_NAME_FIELD_MAX = FULL_NAME_FIELD_MAX;
var ZIP_CART_MIN_AMOUNT = 35;
exports.ZIP_CART_MIN_AMOUNT = ZIP_CART_MIN_AMOUNT;
var ZIP_CART_MAX_AMOUNT = 500;

// Validation Regex
exports.ZIP_CART_MAX_AMOUNT = ZIP_CART_MAX_AMOUNT;
var EMAIL_VALIDATION_REGEX = /^\S+@\S+\.\S+$/;
// eslint-disable-next-line no-useless-escape
exports.EMAIL_VALIDATION_REGEX = EMAIL_VALIDATION_REGEX;
var PHONE_NUMBER_VALIDATION_REGEX = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
exports.PHONE_NUMBER_VALIDATION_REGEX = PHONE_NUMBER_VALIDATION_REGEX;
var CARD_NUMBER_VALIDATION_REGEX = /^([0-9 ]{17,19})$/;
exports.CARD_NUMBER_VALIDATION_REGEX = CARD_NUMBER_VALIDATION_REGEX;
var CARD_EXPIRY_VALIDATION_REGEX = /^(0[1-9]|1[0-2])\/([0-9]{2})$/;
exports.CARD_EXPIRY_VALIDATION_REGEX = CARD_EXPIRY_VALIDATION_REGEX;
var CARD_CVV_VALIDATION_REGEX = /^([0-9]{3,4})$/;
exports.CARD_CVV_VALIDATION_REGEX = CARD_CVV_VALIDATION_REGEX;
var ZIP_CODE_VALIDATION_REGEX = {
  US: /^[0-9]{5}(?:-[0-9]{4})?$/,
  CA: /^[ABCEGHJ-NPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/i,
  BR: /^\d{5}-?\d{3}$/,
  DE: /^(?!01000|99999)(0[1-9]\d{3}|[1-9]\d{4})$/,
  JP: /^〒?[0-9]{3}-?[0-9]{4}$/,
  FR: /^(?:0[1-9]|[13-8][0-9]|2[ab1-9]|9[0-5])(?:[0-9]{3})?|9[78][1-9](?:[0-9]{2})?$/,
  GB: /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})$/,
  MX: /^\d{5}$/,
  AU: /^(?:(?:[2-8]\d|9[0-7]|0?[28]|0?9(?=09))(?:\d{2}))$/,
  ES: /([1-9]{2}|[0-9][1-9]|[1-9][0-9])[0-9]{3}/,
  IT: /^\d{5}$/,
  IE: /(?:^[AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/,
  SE: /^(\d{3} \d{2})/
};
exports.ZIP_CODE_VALIDATION_REGEX = ZIP_CODE_VALIDATION_REGEX;
var BILLING_ADDRESS_VALIDATION_REGEX = /^[^<>?}{~]*$/;
exports.BILLING_ADDRESS_VALIDATION_REGEX = BILLING_ADDRESS_VALIDATION_REGEX;
var NAME_VALIDATION_REGEX = /^[^!#$%^&()/<>?@}{~:]*$/;
exports.NAME_VALIDATION_REGEX = NAME_VALIDATION_REGEX;
var VISA_REGEX = /^4[0-9]{15}(?:[0-9]{3})?$/;
exports.VISA_REGEX = VISA_REGEX;
var MASTER_CARD_REGEX = /^5[1-5][0-9]{14}|^(222[1-9]|22[3-9]\\d|2[3-6]\\d{2}|27[0-1]\\d|2720)[0-9]{12}$/;
exports.MASTER_CARD_REGEX = MASTER_CARD_REGEX;
var AMEX_CARD_REGEX = /^3[47][0-9]{13}$/;
exports.AMEX_CARD_REGEX = AMEX_CARD_REGEX;
var DISCOVER_CARD_REGEX = /^6(?:011|[4-5][0-9]{2})[0-9]{12}$/;
exports.DISCOVER_CARD_REGEX = DISCOVER_CARD_REGEX;
var DINERS_CLUB_CARD_REGEX = /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/;
exports.DINERS_CLUB_CARD_REGEX = DINERS_CLUB_CARD_REGEX;
var NUMBERS_ONLY = /[^0-9]*/g;

// Standard regex identifier for all emoji's and pictographic entries, well supported by JS REGEX.test API
exports.NUMBERS_ONLY = NUMBERS_ONLY;
var EMOJI_REGEX = /(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u2388\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2605\u2607-\u2612\u2614-\u2685\u2690-\u2705\u2708-\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763-\u2767\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDD0F\uDD2F\uDD6C-\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDAD-\uDDE5\uDE01-\uDE0F\uDE1A\uDE2F\uDE32-\uDE3A\uDE3C-\uDE3F\uDE49-\uDFFA]|\uD83D[\uDC00-\uDD3D\uDD46-\uDE4F\uDE80-\uDEFF\uDF74-\uDF7F\uDFD5-\uDFFF]|\uD83E[\uDC0C-\uDC0F\uDC48-\uDC4F\uDC5A-\uDC5F\uDC88-\uDC8F\uDCAE-\uDCFF\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDEFF]|\uD83F[\uDC00-\uDFFD])/;
exports.EMOJI_REGEX = EMOJI_REGEX;
var CARD_TYPES = {
  VISA: 'VI',
  MASTER_CARD: 'MC',
  MAESTRO_CARD: 'ME',
  AMEX: 'AX',
  DISCOVER: 'DI',
  DINERS_CLUB: 'DC'
};
exports.CARD_TYPES = CARD_TYPES;
var PAYMENT_METHOD_LIST = {
  ADYEN_WIDGET: 'AdyenWidget',
  BHN_PAYPAL: 'BhnPaypal',
  NATIVE_PAYMENT: 'NativePayment'
};
exports.PAYMENT_METHOD_LIST = PAYMENT_METHOD_LIST;
var PAYMENT_METHOD_ALIAS = {
  ADYEN_DROPIN: 'ADYEN_DROPIN',
  PAYPAL: 'PAYPAL',
  CREDIT_CARD: 'CREDIT_CARD',
  ZIP_PAY: 'ZIP_PAY',
  GOOGLE_PAY: 'GOOGLE_PAY',
  APPLE_PAY: 'APPLE_PAY'
};
exports.PAYMENT_METHOD_ALIAS = PAYMENT_METHOD_ALIAS;
var ADYEN_PAYMENT_METHOD_TYPES = {
  card: 'ADYEN_CREDIT_CARD',
  scheme: 'ADYEN_CREDIT_CARD',
  ideal: 'ADYEN_IDEAL',
  directEbanking: 'ADYEN_SOFORT',
  giropay: 'ADYEN_GIROPAY',
  pix: 'ADYEN_PIX'
};
exports.ADYEN_PAYMENT_METHOD_TYPES = ADYEN_PAYMENT_METHOD_TYPES;
var GOOGLE_ANALYTICS_CODE = 'UA-221895523-1';
exports.GOOGLE_ANALYTICS_CODE = GOOGLE_ANALYTICS_CODE;
var DATA_DOME_CLIENT_KEY = {
  test: '87B024B36133DBAA93E054371373E7',
  live: '87B024B36133DBAA93E054371373E7'
};
exports.DATA_DOME_CLIENT_KEY = DATA_DOME_CLIENT_KEY;
var DATA_DOME_CAPTCHA_SCRIPT_URL = 'https://js.captcha-display.com/xhr_tag.js';
exports.DATA_DOME_CAPTCHA_SCRIPT_URL = DATA_DOME_CAPTCHA_SCRIPT_URL;
var SUPPORTED_COUNTRY_LOCALE_LIST = ['us', 'br', 'nl', 'ca', 'gb', 'jp', 'mx', 'fr', 'es', 'de', 'br', 'au', 'ie', 'it', 'se'];
exports.SUPPORTED_COUNTRY_LOCALE_LIST = SUPPORTED_COUNTRY_LOCALE_LIST;